/*=========================================================================================
  File Name: moduleVendor.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from './moduleVendorState.js';
import mutations from './moduleVendorMutations.js';
import actions from './moduleVendorActions.js';
import getters from './moduleVendorGetters.js';

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
